import {styled as styledMUI} from "@mui/material/styles";
import {Grid, MenuItem} from "@mui/material";

export const GridFromMUI = styledMUI(Grid)(({theme}) => ({
    // direction:theme.direction,

}));